import React from 'react';
import {useMailCampaignQuery} from 'api';
import styled from 'styled-components';
import {useParams} from 'react-router-dom';
import {Draggable} from 'react-smooth-dnd';
import BlockHeader from './Header';
import BlockTitle from './Title';
import BlockText from './Text';
import BlockImage from './Image';
import BlockButton from './Button';
import BlockDivider from './Divider';
import BlockSocial from './Social';
import BlockVideo from './Video';
import BlockFooter from './Footer';

const iconComponents: {[key: string]: any} = {
  header: BlockHeader,
  title: BlockTitle,
  text: BlockText,
  image: BlockImage,
  button: BlockButton,
  divider: BlockDivider,
  social: BlockSocial,
  video: BlockVideo,
  footer: BlockFooter,
};

interface Props {
  type: string;
  text: string;
}

export default ({type, text}: Props) => {
  const {mailCampaignId} = useParams<{mailCampaignId: string}>();
  const IconComponent = iconComponents[type];

  const {data: {mailCampaign = null} = {}} = useMailCampaignQuery({
    variables: {uuid: mailCampaignId},
    skip: !mailCampaignId,
  });

  return (
    <Draggable>
      <Button
        draft={mailCampaign.status === 'draft'}
        className="toolbar-draggable"
        data-block-type={type}>
        <IconComponent />
        <p>{text}</p>
      </Button>
    </Draggable>
  );
};

const Button = styled.div<{draft?: boolean}>`
  user-select: none;
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  cursor: ${({draft}) => (draft ? 'move' : 'not-allowed')};

  p {
    margin: 0 0 0.5rem;
  }

  svg {
    margin-bottom: 0.5rem;

    path {
      stroke: var(--text-color-2) !important;
    }
  }

  &:hover {
    border: 1px solid var(--primary);
    box-shadow: 0px 0px 4px 1px var(--primary);
  }
`;
